const EMAIL_STRING_VARIANTS = ["email", "e-mail"];

export function getEmailFormElements(): HTMLElement[] {
  const elements: NodeListOf<Element> = document.querySelectorAll("form");
  const matchesSet = new Set<HTMLElement>();

  for (const element of elements) {
    for (const emailString of EMAIL_STRING_VARIANTS) {
      if (
        (element as HTMLElement).innerHTML
          .toLowerCase()
          .includes(emailString.toLowerCase())
      ) {
        matchesSet.add(element as HTMLElement);
        break;
      }
    }
  }

  return Array.from(matchesSet);
}
